<script>
	export default {
		name: 'login-screen',
		render( h ) {
			return h('v-app', [
				h('v-content', [
					h('v-container', {
						attrs: {'fill-height': true},
						class: ['pa-3']
					}, [
						h('v-layout', {
							attrs: {row: true, 'align-center': true}
						}, [
							h('v-flex', {
								attrs: {
									xs12: true,
									sm6: true,
									'offset-sm3': true,
									lg4: true,
									'offset-lg4': true
								}
							}, [
								h('img', {
									attrs: {
										src: require('../assets/logo-rebrand.svg'),
										style: 'width:100%'
									}
								}),
								h('div', this.$slots.default),
								h('p', {
									class: ['mt-4', 'mx-3']
								}, [
									'For technical support, please contact our'
										+' customer support line at ',
									h('a', {
										attrs: {href: 'tel:800-293-9576'}
									}, ['800-293-9576']),
									' or visit the ',
									h('a', {
										attrs: {
											href: 'https://support.bloxdigital.com'
										}
									}, ['BLOX Digital Support Site'])
								])
							])
						])
					])
				])
			]);
		}
	}
</script>
